import { render, staticRenderFns } from "./SelfReport.vue?vue&type=template&id=00be7ea7&"
import script from "./SelfReport.vue?vue&type=script&lang=js&"
export * from "./SelfReport.vue?vue&type=script&lang=js&"
import style0 from "./SelfReport.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports